import ContentView from "modules/common/components/authoring/contentView/contentView";
import React from "react";
import { ContentType } from "modules/common/models";
import { Event } from "modules/events/models";
import DateBlock from "../date-block/dateBlock";
import { asContentOverview } from "modules/common/components/authoring/utils";
import EventTimes from "./components/eventTimes";
import { ConnectedProps, connect } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";
import Topics from "modules/posts/components/post-feed/components/topics/topics";
import CutoffTime from "./components/cutoffTime";
import Location from "./components/location";
import { ActionButtonsContainer } from "../../../common/components/actionButtons/actionButtonsContainer";
import { ActionButtons } from "../../../common/components/actionButtons/actionButtons";
import { actionButtonSettingsAreValid } from "utils/actionButtonSettingsAreValid";

import "../../styles/eventPreviewContent.sass";

interface IEventPreviewContentProps {
    event: Event;
}

const EventPreviewContent: React.FunctionComponent<PropsWithRedux> = ({
    event,
    currentUser,
}) => {
    const eventContent = asContentOverview(event, currentUser.preferredLCID);
    const [activeLcid, setActiveLcid] = React.useState<string>(currentUser.preferredLCID);
    const eventStartTimes = Object.keys(event.eventTimes!)[0];
    const eventHasValidActionButtons = event.eventType !== "informational" ||
        actionButtonSettingsAreValid(event.actionButtons.primaryButtonSettings) ||
        actionButtonSettingsAreValid(event.actionButtons.secondaryButtonSettings);

    return <ContentView
        contentType={ContentType.Event}
        content={eventContent}
        heroBannerChildren={
            <DateBlock 
                eventStartTime={eventStartTimes} 
                eventEndTime={event.eventTimes![eventStartTimes]} 
                eventTimes={event.eventTimes} 
            />
        }
        pageContentInfoComponent={
            <>
                <Location location={event.location} locationLink={event.locationLink} locationLinkLabel={event.locationLinkLabel} />
                <EventTimes
                    activeLcid={activeLcid}
                    eventTimes={event.eventTimes!}
                    translatedContent={event.translatedContent!}
                />
                <CutoffTime cutoffTime={event.cutoffTime} eventType={event.eventType!} />
                {
                    event.tags && event.tags.length &&
                    <Topics topics={event.tags} className="event-content-view-tags" iconSize="small" iconClassName="event-content-view-tags-icon"/>
                }
            </>
        }
        onChangeActiveLcid={(activeLcid) => setActiveLcid(activeLcid)}
        bottomPageContentComponent={
            eventHasValidActionButtons && 
            <ActionButtonsContainer
                showExtraOptions={false}
                actionButtonsComponent={
                    <ActionButtons
                        respondingEnabled
                        actionButtons={event.actionButtons}
                        eventType={event.eventType ?? "informational"}
                    />
                }
            />
        }
        preview
    />;
};

const connector = connect(
    (state: GlobalApplicationState, ownProps: IEventPreviewContentProps) => ({
        ...ownProps,
        currentUser: state.settings.currentUser,
    })
);
type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(EventPreviewContent);